const PATH = {
    dashboard: "/drive",
    files: "/drive/files",
    publicFolder: "/drive/publicFolder",
    contact: "/drive/contacts",
    trash: "/drive/trash",
    shared: "/drive/shared",
    public: "/drive/public",
    favorite: "/drive/favorite",
    plan: "/drive/plan",
    report: "/drive/report",
    settings: "/drive/settings",
    feedback: "/drive/feedback",
    resultPay: "/drive/result-pay",
    confirmPay: (id: number | string = ":id") => `/drive/confirm-pay/${id}`,
    planRecommendation: "/drive/recommendation-plan",
    planHistory: "/drive/history-plan",
    ewanoConfirm: (plan: string = ":plan", amount: string = ":amount") => `/drive/ewano-confirm/${plan}/${amount}`,
    download: "/drive/dl",
    profile: "/drive/profile",
    userSessions: "/drive/profile/sessions",
    search: "/drive/search",
    duplicatedFiles: "/drive/duplicated-files",
    links: (fileID: number | string = ":id") => `/drive/links/${fileID}`,
    sso: "/drive/sso",
    excelEditor: (version?: number | string, parent?: number | string) => {
        const qs = new URLSearchParams("");
        if (version) qs.append("file", version.toString());
        if (parent) qs.append("path", parent.toString());
        return `/drive/excel${qs.toString() ? `?${qs.toString()}` : ""}`;
    },
    auth: {
        login: "/drive/auth/login",
        register: "/drive/auth/register"
    }
};

export default PATH;
